// extracted by mini-css-extract-plugin
module.exports = {"dividerContainer":"Divider_dividerContainer__USoYy","divider":"Divider_divider__aE5S2"};